import PropTypes from 'prop-types'
import React from 'react'

import Cost from 'components/Cost'
import { GOODS_TYPES } from 'constants/sales'
import { LocalizationContext } from 'contexts/Localization'
import { MenuMainContext } from 'contexts/MenuMain'
import { ResizeContext } from 'contexts/Resize'
import useInViewCommon from 'hooks/useInViewCommon'
import useSwiperLoader from 'hooks/useSwiperLoader'
import CartHowItWorksModal from '../CartHowItWorksModal/CartHowItWorksModal'
import CartDisclaimer from '../CartDisclaimer'
import CartFormCommon from '../CartFormCommon'
import { scrollToBlock } from 'utils/client/scroll'
import emptyBasketBase from './assets/empty-basket-base.png'
import freeDeliveryHands from './assets/free-delivery-hands.png'

import {
  // TODO: раскомментировать — временно отключены доп. услуги консультаций
  // AddonBody,
  // AddonCard,
  // AddonConsultant,
  // AddonDuration,
  // AddonMeta,
  // AddonPhoneFrame,
  // AddonThumb,
  // AddonTitle,
  // AddonToggle,
  // AddonToggleKnob,
  CheckoutButton,
  CheckoutOfferError,
  DeliveryBannerAccent,
  DeliveryBannerArt,
  DeliveryBannerCard,
  DeliveryBannerCardMobile,
  DeliveryBannerImage,
  DeliveryBannerTitle,
  DeliveryBannerTitleLine,
  DeliveryBannerTitleBox,
  DiscountChip,
  DiscountLabel,
  DiscountRow,
  DiscountRows,
  DiscountValue,
  DisclaimerSection,
  EmptyIllustrationBase,
  EmptyIllustration,
  EmptyState,
  EmptyText,
  FaqAnswer,
  FaqHeading,
  FaqItem,
  FaqList,
  FaqQuestion,
  FaqQuestionRow,
  FaqSection,
  FaqToggle,
  FormCard,
  HeaderRow,
  HelperLink,
  MainGrid,
  PageTop,
  PromoApplyButton,
  PromoArrow,
  PromoCodeBox,
  PromoFeedback,
  PromoForm,
  PromoInput,
  PromoInputField,
  PromoStateAction,
  PromoStateField,
  PromoStateLabel,
  PromoStateValue,
  PromoTriggerButton,
  PromoTriggerLabel,
  QuantityButton,
  QuantityControl,
  QuantitySign,
  QuantityValue,
  RecommendationButton,
  RecommendationButtonLabel,
  RecommendationCard,
  RecommendationCounter,
  RecommendationCounterButton,
  RecommendationCounterSign,
  RecommendationCounterValue,
  RecommendationImage,
  RecommendationImageWrap,
  RecommendationMetaRow,
  RecommendationOldPrice,
  RecommendationPriceRow,
  RecommendationPricing,
  Recommendations,
  RecommendationsMobileSlider,
  RecommendationsRail,
  RecommendationSlide,
  RecommendationTitle,
  SummaryColumn,
  SummaryCount,
  SummaryGroup,
  SummaryImage,
  SummaryImageFrame,
  SummaryInfo,
  SummaryItem,
  SummaryItems,
  SummaryItemTitle,
  SummaryPriceRow,
  SummarySeparator,
  SummaryTitle,
  SummaryTitleRow,
  Title,
  TitleBreak,
  TotalLabel,
  TotalRow,
} from './styles'

const {
  dna,
  biome,
  wgs,
  // TODO: раскомментировать — временно отключены доп. услуги консультаций
  // dnaConsultation,
  // nutritionConsultation,
} = GOODS_TYPES

const RECOMMENDATIONS_ORDER = [dna, biome, wgs]
// TODO: раскомментировать — временно отключены доп. услуги консультаций
// const ADDON_CONSULTANT_IMAGE = '/static/images/cart-redesign/addon-consultant.png'
// const ADDON_PHONE_FRAME_IMAGE = '/static/images/cart-redesign/addon-phone-frame.png'
const RECOMMENDATIONS_MOBILE_SLIDER_CONFIG = {
  slidesPerView: 1.5,
  spaceBetween: 10,
  slidesOffsetAfter: 20,
  threshold: 8,
  watchOverflow: true,
  breakpoints: {
    768: {
      slidesPerView: 2.3,
    },
  },
}

const HOW_IT_WORKS_LABELS = {
  [dna]: 'dnaHowItWorks',
  [biome]: 'biomeHowItWorks',
  [wgs]: 'wgsHowItWorks',
}

const RECOMMENDATION_IMAGES = {
  [dna]: '/static/images/cart-redesign/recommendation-dna',
  [biome]: '/static/images/cart-redesign/recommendation-biome',
  [wgs]: '/static/images/cart-redesign/recommendation-wgs',
}

// TODO: раскомментировать — временно отключены доп. услуги консультаций
// const CONSULTATION_META = {
//   [dnaConsultation]: {
//     duration: '45 мин',
//     mobileDuration: '45мин',
//     mobileTitle: ['Консультация', 'генетика'],
//     title: 'Консультация генетика',
//   },
//   [nutritionConsultation]: {
//     duration: '60 мин',
//     mobileDuration: '60мин',
//     mobileTitle: ['Консультация', 'нутрициолога'],
//     title: 'Консультация нутрициолога',
//   },
// }
//
// const CONSULTATION_PRODUCT_BY_MAIN_PRODUCT = {
//   [dna]: dnaConsultation,
//   [biome]: nutritionConsultation,
// }

const FAQ_ITEMS = [
  {
    answer:
      '<p>Генетический тест даёт более точное понимание особенностей вашего организма на уровне ДНК. Он позволяет увидеть предрасположенности к заболеваниям, особенности обмена веществ и реакции организма, а также наследственные факторы, которые обычно остаются незаметными.</p>' +
      '<p>Это знание становится основой для более осознанных решений о здоровье с опорой на данные и науку.</p>',
    title: 'Зачем сдавать генетический тест?',
  },
  {
    answer:
      '<p>Никакой специальной подготовки не требуется. В наборе для исследования есть всё необходимое и подробная инструкция.</p>' +
      '<p>Для Генетического теста и Полного генома используется образец слюны. Если вы недавно проходили стоматологическое лечение, лучше подождать несколько дней, так как композитный материал пломб довольно токсичный и может оказать влияние на биоматериал.</p>',
    title: 'Как подготовиться к сдаче теста?',
  },
  {
    answer:
      '<p>Когда вы получите набор для исследования, необходимо будет собрать биоматериал по инструкции, далее зарегистрировать на сайте <a href="https://atlas.ru/auth/login" target="_blank" rel="noopener noreferrer">Личный кабинет</a> с вашим уникальным бар-кодом (он указан на пробирке) и оставить заявку на вызов курьера прямо из личного кабинета. Мы заберём ваш образец и передадим его в лабораторию.</p>' +
      '<p>Собранный биоматериал можно хранить в контейнере до 2-х месяцев без каких-либо специальных условий.</p>' +
      '<p>Мы направим вам письмо, как только результаты исследования будут загружены в ваш личный кабинет на сайте.</p>',
    title: 'Как хранить и отправлять биоматериал?',
  },
]

const chooseWord = (amount, words = []) => {
  if (words.length < 3) return ''

  const mod10 = amount % 10
  const mod100 = amount % 100

  if (mod10 === 1 && mod100 !== 11) return words[0]
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return words[1]
  }

  return words[2]
}

const getBoxImage = (paths, productType) =>
  `${paths.cdn_global}/boxes/${productType}-left-new`

const getRecommendationImage = (paths, productType) =>
  RECOMMENDATION_IMAGES[productType] || getBoxImage(paths, productType)

const getRecommendationImageSrc = (paths, productType) =>
  `${getRecommendationImage(paths, productType)}.png`

const getSummaryImageSrc = (paths, productType) =>
  getRecommendationImageSrc(paths, productType)

const getDiscounts = cart => {
  const totalDiscount = Number(cart?.sum?.diff) || 0

  if (!totalDiscount) {
    return {
      promoDiscount: 0,
      saleDiscount: 0,
    }
  }

  if (cart?.promo?.id) {
    return {
      promoDiscount: totalDiscount,
      saleDiscount: 0,
    }
  }

  return {
    promoDiscount: 0,
    saleDiscount: totalDiscount,
  }
}

const getRecommendationDisplay = (product = {}) => {
  const currentPrice = Number(product.currentPrice || 0)
  const oldPrice = Number(product.price || product.priceWebsite || 0)
  const discount = Number(product.discount) || 0

  return {
    currentPrice,
    discount,
    oldPrice,
  }
}

const CartRussiaRedesign = ({
  cart,
  closePromocode,
  decreaseGoods,
  essential_points,
  increaseGoods,
  isCartInitOrUpdate,
  personalInfoChange,
  privacy,
  sales,
  submitPromocode,
  terms,
  texts,
}) => {
  const { currentCountry, dict, paths } = React.useContext(LocalizationContext)
  const { menuNode } = React.useContext(MenuMainContext)
  const { mobile, tablet } = React.useContext(ResizeContext)
  const [checkoutHandler, setCheckoutHandler] = React.useState(null)
  const [offerError, setOfferError] = React.useState(null)
  const [openedFaqIndex, setOpenedFaqIndex] = React.useState(0)
  const [isHowItWorksOpen, setIsHowItWorksOpen] = React.useState(false)
  const [isPromoOpen, setIsPromoOpen] = React.useState(false)
  const [isPromoFocused, setIsPromoFocused] = React.useState(false)
  const [promoValue, setPromoValue] = React.useState(cart?.promo?.name || '')
  const topRef = React.useRef(null)
  const [recommendationsRef, recommendationsInView] = useInViewCommon()
  const {
    Swiper: RecommendationsSwiper,
    swiperLoaded: recommendationsSwiperLoaded,
  } = useSwiperLoader({
    inView: (mobile || tablet) && recommendationsInView,
  })

  const isCartEmpty = cart.sum.amount === 0
  // TODO: uncomment below and set out of stock to false
  //const isDisabled = isCartInitOrUpdate || cart.isOrderCollected
  const isDisabled = true
  const temporarilyOutOfStock = true

  const activeGoods = React.useMemo(() => {
    if (!sales.goods) return []

    return RECOMMENDATIONS_ORDER.filter(
      productType =>
        sales.goods[productType]?.isActive &&
        cart.goods[productType]?.amount > 0,
    )
  }, [cart.goods, sales.goods])

  const howItWorksLabelKey = React.useMemo(() => {
    const primaryType = activeGoods[0] || dna

    return HOW_IT_WORKS_LABELS[primaryType] || HOW_IT_WORKS_LABELS[dna]
  }, [activeGoods])

  const recommendedGoods = React.useMemo(() => {
    if (!sales.goods) return []

    return RECOMMENDATIONS_ORDER.filter(
      productType => sales.goods[productType]?.isActive,
    )
  }, [sales.goods])
  const hasRecommendationDiscounts = React.useMemo(
    () =>
      recommendedGoods.some(productType => {
        const product = sales.goods?.[productType]

        if (!product) return false

        const recommendationDisplay = getRecommendationDisplay(product)

        return (
          recommendationDisplay.currentPrice > 0 &&
          recommendationDisplay.oldPrice > recommendationDisplay.currentPrice
        )
      }),
    [recommendedGoods, sales.goods],
  )

  const goodsWord = React.useMemo(
    () => chooseWord(cart.sum.amount, texts.form.order.goods_words),
    [cart.sum.amount, texts.form.order.goods_words],
  )

  const orderTitleParts = React.useMemo(
    () =>
      String(texts.form.order_title || '')
        .trim()
        .split(/\s+/),
    [texts.form.order_title],
  )

  const { promoDiscount, saleDiscount } = React.useMemo(
    () => getDiscounts(cart),
    [cart],
  )
  const hasDiscounts = saleDiscount > 0 || promoDiscount > 0
  const promoName = cart.promo.name || ''
  const promoDisplayValue = cart.promo.id ? promoName : promoValue.trim()
  const promoResetLabel = React.useMemo(() => {
    const resetLabel = texts.promocode.reset_button || ''

    return resetLabel.replace(/\s+промокод$/i, '') || resetLabel
  }, [texts.promocode.reset_button])

  const promoError = React.useMemo(
    () => texts.promocode.errors?.[cart.promo.errors.errorCode] || null,
    [cart.promo.errors.errorCode, texts.promocode.errors],
  )
  const isPromoFilled = Boolean(promoValue.trim())
  const isPromoEditing = isPromoOpen || Boolean(promoError && promoDisplayValue)
  const isPromoLabelFloating = isPromoFocused || isPromoFilled

  React.useEffect(() => {
    setPromoValue(promoName)
  }, [promoName])

  React.useEffect(() => {
    document.body.classList.add('cart-route')

    return () => {
      document.body.classList.remove('cart-route')
    }
  }, [])

  React.useEffect(() => {
    if (cart.promo.id) {
      setIsPromoOpen(false)
      setIsPromoFocused(false)
    }
  }, [cart.promo.id])

  const handleCheckout = React.useCallback(() => {
    if (checkoutHandler) checkoutHandler()
  }, [checkoutHandler])

  const handleAddRecommended = React.useCallback(
    productType => () => {
      increaseGoods({
        isSubscription: false,
        productType,
      })

      scrollToBlock(topRef, menuNode)
    },
    [increaseGoods, menuNode],
  )

  // TODO: раскомментировать — временно отключены доп. услуги консультаций
  // const handleToggleConsultation = React.useCallback(
  //   consultationType => () => {
  //     const amount = cart.goods?.[consultationType]?.amount || 0
  //
  //     if (amount > 0) {
  //       decreaseGoods({
  //         isSubscription: false,
  //         num: amount,
  //         productType: consultationType,
  //       })
  //       return
  //     }
  //
  //     increaseGoods({
  //       isSubscription: false,
  //       productType: consultationType,
  //     })
  //   },
  //   [cart.goods, decreaseGoods, increaseGoods],
  // )

  // TODO: раскомментировать — временно отключены доп. услуги консультаций
  // React.useEffect(() => {
  //   Object.entries(CONSULTATION_PRODUCT_BY_MAIN_PRODUCT).forEach(
  //     ([productType, consultationType]) => {
  //       const isPrimaryAdded = (cart.goods?.[productType]?.amount || 0) > 0
  //       const consultationAmount = cart.goods?.[consultationType]?.amount || 0
  //       const isConsultationActive = sales.goods?.[consultationType]?.isActive
  //
  //       if ((!isPrimaryAdded || !isConsultationActive) && consultationAmount > 0) {
  //         decreaseGoods({
  //           isSubscription: false,
  //           num: consultationAmount,
  //           productType: consultationType,
  //         })
  //       }
  //     },
  //   )
  // }, [cart.goods, decreaseGoods, sales.goods])

  const handlePromoSubmit = React.useCallback(
    event => {
      event.preventDefault()
      submitPromocode({ promocode: promoValue })
    },
    [promoValue, submitPromocode],
  )

  const handlePromoReset = React.useCallback(() => {
    closePromocode()
    submitPromocode({ promocode: null })
    setPromoValue('')
    setIsPromoOpen(false)
  }, [closePromocode, submitPromocode])

  const renderRecommendationCard = React.useCallback(
    productType => {
      const product = sales.goods[productType]
      const recommendationDisplay = getRecommendationDisplay(product)
      const amount = cart.goods?.[productType]?.amount || 0
      const isZeroPrice =
        product.price === 0 ||
        product.currentPrice === 0 ||
        product.priceWebsite === 0
      const hasDiscount =
        !isZeroPrice &&
        recommendationDisplay.oldPrice > recommendationDisplay.currentPrice
      const shouldReserveDiscountSpace =
        hasRecommendationDiscounts && !isZeroPrice

      return (
        <RecommendationCard key={productType}>
          <RecommendationImageWrap>
            <RecommendationImage
              alt=""
              $productType={productType}
              src={getRecommendationImageSrc(paths, productType)}
            />
          </RecommendationImageWrap>

          <RecommendationTitle>
            {texts.products[productType].title}
          </RecommendationTitle>

          {!isZeroPrice && (
            <RecommendationPricing>
              {shouldReserveDiscountSpace && (
                <RecommendationMetaRow
                  $reserveDiscountSpace={shouldReserveDiscountSpace}
                >
                  {hasDiscount && (
                    <>
                      <RecommendationOldPrice>
                        <Cost
                          currency={sales.currency}
                          intlCode={currentCountry.intlCode}
                          precision={sales.precision}
                          size="xs"
                          value={recommendationDisplay.oldPrice}
                        />
                      </RecommendationOldPrice>

                      {recommendationDisplay.discount > 0 && (
                        <DiscountChip>
                          {`-${recommendationDisplay.discount}%`}
                        </DiscountChip>
                      )}
                    </>
                  )}
                </RecommendationMetaRow>
              )}

              <RecommendationPriceRow>
                <Cost
                  currency={sales.currency}
                  intlCode={currentCountry.intlCode}
                  precision={sales.precision}
                  size="baseMedium"
                  value={recommendationDisplay.currentPrice}
                />
              </RecommendationPriceRow>
            </RecommendationPricing>
          )}

          {amount > 0 ? (
            <>
              {temporarilyOutOfStock ? (
                <RecommendationButton disabled={true} type="button">
                  <RecommendationButtonLabel
                    dangerouslySetInnerHTML={{
                      __html: dict.buttons.temporarily_out_of_stock,
                    }}
                  />
                </RecommendationButton>
              ) : (
                <RecommendationCounter>
                  <RecommendationCounterButton
                    aria-label="Уменьшить количество"
                    disabled={isDisabled}
                    $kind="minus"
                    onClick={() =>
                      decreaseGoods({
                        isSubscription: false,
                        productType,
                      })
                    }
                    type="button"
                  >
                    <RecommendationCounterSign $kind="minus" />
                  </RecommendationCounterButton>
                  <RecommendationCounterValue>
                    {amount}
                  </RecommendationCounterValue>
                  <RecommendationCounterButton
                    aria-label="Увеличить количество"
                    disabled={isDisabled}
                    $kind="plus"
                    onClick={() =>
                      increaseGoods({
                        isSubscription: false,
                        productType,
                      })
                    }
                    type="button"
                  >
                    <RecommendationCounterSign $kind="plus" />
                  </RecommendationCounterButton>
                </RecommendationCounter>
              )}
            </>
          ) : (
            <RecommendationButton
              disabled={isDisabled || isZeroPrice}
              onClick={handleAddRecommended(productType)}
              type="button"
            >
              {temporarilyOutOfStock ? (
                <RecommendationButtonLabel
                  dangerouslySetInnerHTML={{
                    __html: dict.buttons.temporarily_out_of_stock,
                  }}
                />
              ) : (
                <RecommendationButtonLabel
                  dangerouslySetInnerHTML={{
                    __html:
                      dict.buttons.add_to_cart_new || dict.buttons.add_to_cart,
                  }}
                />
              )}
            </RecommendationButton>
          )}
        </RecommendationCard>
      )
    },
    [
      cart.goods,
      currentCountry.intlCode,
      decreaseGoods,
      dict.buttons.add_to_cart,
      dict.buttons.add_to_cart_new,
      handleAddRecommended,
      increaseGoods,
      isDisabled,
      hasRecommendationDiscounts,
      paths,
      sales.currency,
      sales.goods,
      sales.precision,
      texts.products,
    ],
  )

  const renderDeliveryBanner = React.useCallback(isMobileSlide => {
    const BannerComponent = isMobileSlide
      ? DeliveryBannerCardMobile
      : DeliveryBannerCard

    return (
      <BannerComponent>
        <DeliveryBannerTitleBox>
          <DeliveryBannerTitle>
            <DeliveryBannerAccent>бесплатная</DeliveryBannerAccent>
            <DeliveryBannerTitleLine>доставка</DeliveryBannerTitleLine>
            <DeliveryBannerTitleLine>по всей России</DeliveryBannerTitleLine>
          </DeliveryBannerTitle>
        </DeliveryBannerTitleBox>
        <DeliveryBannerArt>
          <DeliveryBannerImage alt="" src={freeDeliveryHands} />
        </DeliveryBannerArt>
      </BannerComponent>
    )
  }, [])

  return (
    <>
      <PageTop ref={topRef}>
        <HeaderRow>
          <Title>
            {orderTitleParts[0]}
            {orderTitleParts.length > 1 && (
              <TitleBreak>{orderTitleParts.slice(1).join(' ')}</TitleBreak>
            )}
          </Title>
          <HelperLink onClick={() => setIsHowItWorksOpen(true)}>
            {dict.links?.[howItWorksLabelKey] || 'Как это работает?'}
          </HelperLink>
        </HeaderRow>
      </PageTop>

      <MainGrid>
        <FormCard isCartEmpty={isCartEmpty}>
          <CartFormCommon
            cart={cart}
            dict={dict}
            hideCheckoutButton={!mobile}
            isEmbedded={true}
            personalInfoChange={personalInfoChange}
            registerCheckoutHandler={setCheckoutHandler}
            registerOfferError={setOfferError}
            rules={{ essential_points, terms, privacy }}
            texts={texts}
          />
        </FormCard>

        <SummaryColumn isCartEmpty={isCartEmpty}>
          <SummaryTitleRow>
            <SummaryTitle>{texts.form.order.title}</SummaryTitle>
            {!isCartEmpty && (
              <SummaryCount>{`${cart.sum.amount} ${goodsWord}`}</SummaryCount>
            )}
          </SummaryTitleRow>

          {isCartEmpty ? (
            <EmptyState>
              <EmptyIllustration>
                <EmptyIllustrationBase alt="" src={emptyBasketBase} />
              </EmptyIllustration>
              <EmptyText
                dangerouslySetInnerHTML={{
                  __html: texts.empty_cart.empty_text,
                }}
              />
            </EmptyState>
          ) : (
            <>
              <SummaryItems>
                {activeGoods.map((productType, index) => {
                  const productInfo = cart.goods[productType]
                  // TODO: раскомментировать — временно отключены доп. услуги консультаций
                  // const hasSyntheticMobileWgsConsultation =
                  //   mobile &&
                  //   productType === wgs &&
                  //   sales.goods?.[dnaConsultation]?.isActive
                  // const consultationType =
                  //   CONSULTATION_PRODUCT_BY_MAIN_PRODUCT[productType] ||
                  //   (hasSyntheticMobileWgsConsultation ? dnaConsultation : null)
                  // const consultationProduct = consultationType
                  //   ? sales.goods?.[consultationType]
                  //   : null
                  // const consultationMeta =
                  //   consultationType && consultationProduct?.isActive
                  //     ? CONSULTATION_META[consultationType]
                  //     : null
                  // const isSyntheticConsultation =
                  //   hasSyntheticMobileWgsConsultation &&
                  //   !CONSULTATION_PRODUCT_BY_MAIN_PRODUCT[productType]
                  // const consultationPrice =
                  //   consultationProduct?.currentPrice ||
                  //   consultationProduct?.priceWebsite ||
                  //   consultationProduct?.price ||
                  //   0
                  // const isConsultationAdded =
                  //   !isSyntheticConsultation &&
                  //   consultationType &&
                  //   (cart.goods?.[consultationType]?.amount || 0) > 0
                  const isLast = index === activeGoods.length - 1

                  return (
                    <SummaryGroup key={productType}>
                      <SummaryItem>
                        <SummaryImageFrame>
                          <SummaryImage
                            $productType={productType}
                            alt=""
                            src={getSummaryImageSrc(paths, productType)}
                          />
                        </SummaryImageFrame>

                        <SummaryInfo>
                          <SummaryItemTitle>
                            {texts.products[productType].title}
                          </SummaryItemTitle>
                          <SummaryPriceRow>
                            <Cost
                              currency={sales.currency}
                              intlCode={currentCountry.intlCode}
                              precision={sales.precision}
                              size="xs"
                              value={productInfo.cost}
                            />
                          </SummaryPriceRow>
                        </SummaryInfo>

                        <QuantityControl>
                          <QuantityButton
                            $kind="minus"
                            disabled={isDisabled || productInfo.amount < 1}
                            onClick={() =>
                              decreaseGoods({
                                isSubscription: productInfo.isSubscription,
                                productType,
                              })
                            }
                            type="button"
                          >
                            <QuantitySign $kind="minus" />
                          </QuantityButton>
                          <QuantityValue>{productInfo.amount}</QuantityValue>
                          <QuantityButton
                            $kind="plus"
                            disabled={isDisabled}
                            onClick={() =>
                              increaseGoods({
                                isSubscription: productInfo.isSubscription,
                                productType,
                              })
                            }
                            type="button"
                          >
                            <QuantitySign $kind="plus" />
                          </QuantityButton>
                        </QuantityControl>
                      </SummaryItem>

                      {/* TODO: раскомментировать — временно отключены доп. услуги консультаций */}
                      {/* {consultationMeta && consultationType && (
                        <AddonCard>
                          <AddonThumb>
                            <AddonPhoneFrame
                              alt=""
                              src={ADDON_PHONE_FRAME_IMAGE}
                            />
                            <AddonConsultant
                              alt=""
                              src={ADDON_CONSULTANT_IMAGE}
                            />
                          </AddonThumb>

                          <AddonBody>
                            <AddonTitle>
                              {mobile && consultationMeta.mobileTitle ? (
                                consultationMeta.mobileTitle.map((line, lineIndex) => (
                                  <React.Fragment key={line}>
                                    {lineIndex > 0 && <br />}
                                    {line}
                                  </React.Fragment>
                                ))
                              ) : (
                                consultationMeta.title
                              )}
                            </AddonTitle>
                            <AddonMeta>
                              <Cost
                                currency={sales.currency}
                                intlCode={currentCountry.intlCode}
                                precision={sales.precision}
                                size="xs"
                                value={consultationPrice}
                              />
                              <AddonDuration>
                                {mobile && consultationMeta.mobileDuration
                                  ? consultationMeta.mobileDuration
                                  : consultationMeta.duration}
                              </AddonDuration>
                            </AddonMeta>
                          </AddonBody>

                          <AddonToggle
                            $isActive={isConsultationAdded}
                            disabled={isDisabled}
                            onClick={
                              isSyntheticConsultation
                                ? undefined
                                : handleToggleConsultation(consultationType)
                            }
                            type="button"
                          >
                            <AddonToggleKnob
                              $isActive={isConsultationAdded}
                            />
                          </AddonToggle>
                        </AddonCard>
                      )} */}

                      {!isLast && <SummarySeparator />}
                    </SummaryGroup>
                  )
                })}
              </SummaryItems>

              {!sales.isPromoHidden && (
                <PromoCodeBox>
                  {cart.promo.id ? (
                    <>
                      <PromoStateField as="div">
                        <PromoStateLabel $isFloating={true}>
                          {texts.promocode.title}
                        </PromoStateLabel>
                        <PromoStateValue>{promoDisplayValue}</PromoStateValue>
                        <PromoStateAction
                          $isReset={true}
                          onClick={handlePromoReset}
                          type="button"
                        >
                          {promoResetLabel}
                        </PromoStateAction>
                      </PromoStateField>
                      <PromoFeedback
                        $isSuccess={true}
                        dangerouslySetInnerHTML={{
                          __html: texts.promocode.success,
                        }}
                      />
                    </>
                  ) : isPromoEditing ? (
                    <PromoForm onSubmit={handlePromoSubmit}>
                      <PromoInputField>
                        <PromoInput
                          $isFloating={isPromoLabelFloating}
                          onBlur={() => setIsPromoFocused(false)}
                          onChange={event => {
                            if (cart.promo.errors.errorCode) {
                              closePromocode()
                            }

                            setPromoValue(event.target.value)
                          }}
                          onFocus={() => setIsPromoFocused(true)}
                          placeholder=""
                          type="text"
                          value={promoValue}
                        />
                        <PromoStateLabel $isFloating={isPromoLabelFloating}>
                          {texts.promocode.title}
                        </PromoStateLabel>
                        <PromoApplyButton
                          disabled={
                            !promoValue.trim() ||
                            cart.promo.isFetching ||
                            cart.isOrderCollected
                          }
                          type="submit"
                        >
                          <PromoArrow aria-hidden="true" />
                        </PromoApplyButton>
                      </PromoInputField>
                      {promoError && (
                        <PromoFeedback
                          $isError={true}
                          dangerouslySetInnerHTML={{ __html: promoError }}
                        />
                      )}
                    </PromoForm>
                  ) : (
                    <PromoTriggerButton
                      onClick={() => {
                        closePromocode()
                        setIsPromoOpen(true)
                        setIsPromoFocused(true)
                      }}
                      type="button"
                    >
                      <PromoTriggerLabel>
                        {texts.promocode.title}
                      </PromoTriggerLabel>
                      <PromoArrow aria-hidden="true" />
                    </PromoTriggerButton>
                  )}

                  {sales.isPromoDisabled && !cart.promo.id && (
                    <PromoFeedback
                      dangerouslySetInnerHTML={{
                        __html: texts.promocode.disabled,
                      }}
                    />
                  )}
                </PromoCodeBox>
              )}

              {hasDiscounts && (
                <DiscountRows>
                  {saleDiscount > 0 && (
                    <DiscountRow>
                      <DiscountLabel
                        dangerouslySetInnerHTML={{
                          __html: texts.form.order.discount,
                        }}
                      />
                      <DiscountValue>
                        <Cost
                          currency={sales.currency}
                          intlCode={currentCountry.intlCode}
                          precision={sales.precision}
                          size="xs"
                          value={-saleDiscount}
                        />
                      </DiscountValue>
                    </DiscountRow>
                  )}

                  {promoDiscount > 0 && (
                    <DiscountRow>
                      <DiscountLabel>Скидка по промокоду</DiscountLabel>
                      <DiscountValue>
                        <Cost
                          currency={sales.currency}
                          intlCode={currentCountry.intlCode}
                          precision={sales.precision}
                          size="xs"
                          value={-promoDiscount}
                        />
                      </DiscountValue>
                    </DiscountRow>
                  )}
                </DiscountRows>
              )}

              <TotalRow $hasDiscounts={hasDiscounts}>
                <TotalLabel>{texts.total.title}</TotalLabel>
                <Cost
                  currency={sales.currency}
                  intlCode={currentCountry.intlCode}
                  precision={sales.precision}
                  size="baseMedium"
                  value={cart.sum.cost}
                />
              </TotalRow>

              {!mobile &&(
                <>
                  {temporarilyOutOfStock ? (
                    <div>
                          {dict.info.temporarily_out_of_stock_description}
                    </div>
                  ) : (
                    <>
                      <CheckoutButton
                        disabled={isDisabled || !checkoutHandler}
                        onClick={handleCheckout}
                        type="button"
                      >
                        {dict.buttons.checkout}
                      </CheckoutButton>

                      <CheckoutOfferError
                        $visible={Boolean(offerError)}
                        dangerouslySetInnerHTML={{
                          __html: offerError || '&nbsp;',
                        }}
                      />
                    </>
                  )}
                </>
              )}
            </>
          )}
        </SummaryColumn>
      </MainGrid>

      <Recommendations ref={recommendationsRef}>
        {(mobile || tablet) &&
        RecommendationsSwiper &&
        recommendationsSwiperLoaded ? (
          <RecommendationsMobileSlider>
            <RecommendationsSwiper {...RECOMMENDATIONS_MOBILE_SLIDER_CONFIG}>
              {recommendedGoods.map(productType => (
                <RecommendationSlide key={productType}>
                  {renderRecommendationCard(productType)}
                </RecommendationSlide>
              ))}
              <RecommendationSlide key="free-delivery-banner">
                {renderDeliveryBanner(true)}
              </RecommendationSlide>
            </RecommendationsSwiper>
          </RecommendationsMobileSlider>
        ) : (
          <RecommendationsRail>
            {recommendedGoods.map(renderRecommendationCard)}
            {renderDeliveryBanner(false)}
          </RecommendationsRail>
        )}
      </Recommendations>

      <FaqSection>
        <FaqHeading>{dict.block_faq.title}</FaqHeading>
        <FaqList>
          {FAQ_ITEMS.map((item, index) => {
            const isOpened = openedFaqIndex === index

            return (
              <FaqItem isOpened={isOpened} key={item.title}>
                <FaqQuestionRow
                  onClick={() =>
                    setOpenedFaqIndex(prevIndex =>
                      prevIndex === index ? -1 : index,
                    )
                  }
                  type="button"
                >
                  <FaqQuestion>{item.title}</FaqQuestion>
                  <FaqToggle $isOpened={isOpened} aria-hidden="true" />
                </FaqQuestionRow>
                {isOpened && (
                  <FaqAnswer
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                )}
              </FaqItem>
            )
          })}
        </FaqList>
      </FaqSection>

      <DisclaimerSection>
        <CartDisclaimer
          content={texts.disclaimer}
          isWide={true}
          mobile={mobile}
        />
      </DisclaimerSection>

      <CartHowItWorksModal
        isOpen={isHowItWorksOpen}
        onClose={() => setIsHowItWorksOpen(false)}
      />
    </>
  )
}

CartRussiaRedesign.propTypes = {
  cart: PropTypes.object.isRequired,
  closePromocode: PropTypes.func.isRequired,
  decreaseGoods: PropTypes.func.isRequired,
  essential_points: PropTypes.shape({
    list: PropTypes.array,
    title: PropTypes.string,
  }),
  increaseGoods: PropTypes.func.isRequired,
  isCartInitOrUpdate: PropTypes.bool.isRequired,
  personalInfoChange: PropTypes.func.isRequired,
  privacy: PropTypes.shape({
    list: PropTypes.array,
    title: PropTypes.string,
  }),
  sales: PropTypes.object.isRequired,
  submitPromocode: PropTypes.func.isRequired,
  terms: PropTypes.shape({
    list: PropTypes.array,
    title: PropTypes.string,
  }),
  texts: PropTypes.object.isRequired,
}

CartRussiaRedesign.defaultProps = {
  essential_points: null,
  privacy: null,
  terms: null,
}

export default CartRussiaRedesign
